import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { reduxFirestore } from 'redux-firestore';

import { routerMiddlewareWithHistory } from 'modules/core/modules/router';
import * as Consts from 'constants/index';

import * as loglevel from 'config/loglevel';
import { sentryEnhancer } from 'config/sentry';
import { firebase } from 'config/firebase';

import createRootReducer from './createRootReducer';
import createRootSaga from './createRootSaga';

const createStoreWithFirebase = reduxFirestore(firebase)(createStore);

const configureStore = ({ initialState, reducers, saga, middlewares: customMiddlewares }) => {
    const isNotProd = process.env.NODE_ENV !== Consts.env.PRODUCTION;
    const sagaMiddleware = createSagaMiddleware({
        onError(e) {
            loglevel.error(e);
        },
    });
    const middlewares = [routerMiddlewareWithHistory, sagaMiddleware].concat(customMiddlewares);
    const enhancerArgs = [applyMiddleware(...middlewares), sentryEnhancer];

    if (isNotProd) {
        enhancerArgs.push(window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : r => r);
    }

    const rootReducer = createRootReducer(reducers);
    const enhancer = compose(...enhancerArgs);
    const store = createStoreWithFirebase(rootReducer, initialState, enhancer);

    const rootSaga = createRootSaga(saga);
    sagaMiddleware.run(rootSaga);

    return store;
};

export default configureStore;
